/**
 * Numeric App Store id from App Store Connect.
 * Leave this empty until that id is known. The Smart App Banner meta tag
 * and the store button stay off without it. The dismissible banner still shows.
 */
const APP_STORE_ID = '';

function isIosBrowser(userAgent, platform, maxTouchPoints) {
  const ua = String(userAgent || '');
  const touchMac = platform === 'MacIntel' && Number(maxTouchPoints) > 1;
  return /iPad|iPhone|iPod/.test(ua) || touchMac;
}

function shouldOfferGetTheApp({ native, userAgent, platform, maxTouchPoints, dismissed }) {
  if (native || dismissed) return false;
  return isIosBrowser(userAgent, platform, maxTouchPoints);
}

function appStoreUrl(id = APP_STORE_ID) {
  const value = String(id || '').trim();
  if (!/^\d+$/.test(value)) return '';
  return `https://apps.apple.com/app/id${value}`;
}

function readAppStoreConfig(source) {
  const input = source || {};
  const id = String(input.id || '').trim();
  const url = String(input.url || '').trim();
  return {
    id: /^\d{6,12}$/.test(id) ? id : '',
    url: /^https:\/\/apps\.apple\.com\//.test(url) ? url : '',
  };
}

module.exports = {
  APP_STORE_ID,
  isIosBrowser,
  shouldOfferGetTheApp,
  appStoreUrl,
  readAppStoreConfig,
};
